import { getQuizAnswers } from "@helpers/quizAnswers"
import { TFunction } from "i18next"
import i18n from "../../i18n"

const DEFAULT_MINUTES = 15
const MINUTES_PER_MIND_MAP = 12
const DAYS_PER_MONTH = 30

export interface Personalization {
  goalId: string
  goalLabel: string
  learnerTypeLabel: string
  mindMapsPerMonth: number
  minutes: number
  momentLabel: string
  topicLabels: string[]
}

const LANGUAGES_WITH_CAPITALIZED_NOUNS = ["de"]

export function toInlineLabel(label: string): string {
  const language = i18n.resolvedLanguage?.split("-")[0] ?? "en"
  if (LANGUAGES_WITH_CAPITALIZED_NOUNS.includes(language)) return label

  return label.charAt(0).toLocaleLowerCase(language) + label.slice(1)
}

export function getMindMapsPerMonth(minutes: number): number {
  return Math.round((minutes * DAYS_PER_MONTH) / MINUTES_PER_MIND_MAP)
}

export default function getPersonalization(t: TFunction): Personalization {
  const answers = getQuizAnswers()

  const optionLabel = (stepId: string, optionId: string | undefined) =>
    optionId ? t(`pages.onboarding.steps.${stepId}.options.${optionId}`) : ""

  const goalId = answers["main-goal"]?.[0] ?? "new-skills"
  const minutes = Number(answers["learning-time"]?.[0]) || DEFAULT_MINUTES

  return {
    goalId,
    goalLabel: t(`pages.onboarding.goals.${goalId}`),
    learnerTypeLabel: optionLabel("learner-type", answers["learner-type"]?.[0]),
    mindMapsPerMonth: getMindMapsPerMonth(minutes),
    minutes,
    momentLabel: optionLabel(
      "learning-moment",
      answers["learning-moment"]?.[0],
    ),
    topicLabels: (answers["topics"] ?? [])
      .slice(0, 3)
      .map((topicId) => optionLabel("topics", topicId)),
  }
}
